import {Part} from "../part";
import {PartMenuType} from "../../../visComponents/constants";
import { showerAccessoriesThumbnail } from '../../../bvComponent/core/assets';

import Table from "../subparts/accessories/table";
import Chair from "../subparts/accessories/chair";
import Carpet from "../subparts/accessories/carpet";
import Lamp from "../subparts/accessories/lamp";
import Basket from "../subparts/accessories/basket";
import Frame from "../subparts/accessories/frame";
import Plant from "../subparts/accessories/plant";

export class Accessories extends Part {
  static id = 'Accessories';

  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partThumbnail = showerAccessoriesThumbnail;
    this.partName = 'Accessories';
    this.translateId = "visualizer.bathroom.accessories2";
    this.relatedItems = [];

    // related items
    this.table = null;
    this.chair = null;
    this.lamp = null;
    this.carpet = null;
    this.basket = null;
    this.frame = null;
    this.plant = null;

    //current active caddie type
    this.relatedGroupNames = ["Table", "Chair", "Lamp", "Carpet", "Basket", "Frame", "Plant"];
  }
  load(dbFeature, loadFeature = true) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Table": {
        relatedItemName = "table";
        RelatedItemClass = Table;
        break;
      }
      case "Chair": {
        relatedItemName = "chair";
        RelatedItemClass = Chair;
        break;
      }
      case "Lamp":
      case "Lamps": {
        relatedItemName = "lamp";
        RelatedItemClass = Lamp;
        break;
      }
      case "Carpet":
      case "Carpets": {
        relatedItemName = "carpet";
        RelatedItemClass = Carpet;
        break;
      }
      case "Basket": {
        relatedItemName = "basket";
        RelatedItemClass = Basket;
        break;
      }
      case "Frame": {
        relatedItemName = "frame";
        RelatedItemClass = Frame;
        break;
      }
      case "Plant": {
        relatedItemName = "plant";
        RelatedItemClass = Plant;
        break;
      }
    }
    return this.loadCommon(relatedItemName, RelatedItemClass, dbFeature, loadFeature)
  }

}

